import styled from "styled-components";

import { InvoicesContainer } from "../Invoices/InvoicesStyles";

interface ITableHeader {
  gridTemplateColumns?: string;
}
export const TableHeader = styled.div<ITableHeader>`
  ${(props) => `
    color: ${props.theme.colors.blackTextBody + props.theme.transparencies.p58};
    font-family: ${props.theme.fontFamilies.primaryFont};
    grid-template-columns: ${props.gridTemplateColumns};
  `}
  align-items: center;
  display: grid;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding: 0 0.3rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .left-aligned-header {
    align-items: flex-start;
    margin-left: 2rem;
    text-align: left;
  }
`;

export const VctTicketsContainer = styled(InvoicesContainer)`
  padding: 1.56rem 2rem;
`;

export const FakeRow = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-size: 1400px 104px;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 8%, #f6f6f6 18%, #ffffff 33%);
  border-radius: 1rem;
  height: 6.3rem;
  margin: 1rem 0;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -668px 0;
    }
    100% {
      background-position: 668px 0;
    }
  }
`;
